import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, User, LogOut, ChevronDown } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/squadra", label: "Squadra" },
  { to: "/palestra", label: "Palestra" },
  { to: "/calendario", label: "Calendario" },
  { to: "/ritiri-estivi", label: "Ritiri estivi" },
  { to: "/news", label: "News" },
  { to: "/chi-siamo", label: "Chi siamo" },
  { to: "/contatti", label: "Contatti" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-zinc-950/70 border-b border-white/5" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 min-h-16 py-2 flex items-center justify-between lg:h-16 lg:py-0">
       <Link to="/" className="flex items-center gap-2.5 group" data-testid="navbar-logo">
  <div className="relative h-10 w-10 rounded-lg bg-zinc-900 flex items-center justify-center shadow-[0_0_24px_rgba(250,204,21,0.25)] group-hover:scale-105 transition-transform overflow-hidden">
    <img
      src="https://okatgbxionqjmzhnazqx.supabase.co/storage/v1/object/public/Immagini%20Sito/3f805aff4915480780d328e1c05cbaab.png"
      alt="ASD Rubiana Calcio"
      className="h-full w-full object-contain p-1"
    />
  </div>
  <div className="leading-normal pt-1 lg:pt-0">
    <div className="font-display font-black text-sm leading-tight tracking-tight uppercase text-zinc-50">ASD Rubiana Calcio</div>
    <div className="font-display text-[10px] leading-normal tracking-[0.25em] uppercase text-yellow-400">Calcio • Palestra</div>
  </div>
</Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.to === "/"}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-medium font-display tracking-wide rounded-md transition-colors ${
                  isActive ? "text-yellow-400" : "text-zinc-300 hover:text-zinc-50"
                }`
              }
              data-testid={`nav-link-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <DropdownMenu>
              <DropdownMenuTrigger className="flex items-center gap-2 px-3 py-2 rounded-full border border-zinc-800 hover:border-zinc-600 transition-colors text-sm" data-testid="user-menu-trigger">
                <div className="h-7 w-7 rounded-full bg-yellow-400 text-zinc-950 font-bold flex items-center justify-center font-display text-xs">
                  {(user.name || user.email).slice(0, 1).toUpperCase()}
                </div>
                <span className="hidden sm:block max-w-[120px] truncate">{user.name || user.email}</span>
                <ChevronDown className="h-4 w-4 opacity-60" />
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="bg-zinc-900 border-zinc-800 text-zinc-100">
                <DropdownMenuLabel>{user.email}</DropdownMenuLabel>
                <DropdownMenuSeparator className="bg-zinc-800" />
                <DropdownMenuItem onClick={() => navigate("/app")} className="cursor-pointer focus:bg-zinc-800" data-testid="menu-gestionale">
                  <User className="h-4 w-4 mr-2" /> Area riservata
                </DropdownMenuItem>
                {user.role === "admin" && (
                  <DropdownMenuItem onClick={() => navigate("/admin")} className="cursor-pointer focus:bg-zinc-800 text-yellow-400" data-testid="menu-admin">
                    <User className="h-4 w-4 mr-2" /> Pannello Admin
                  </DropdownMenuItem>
                )}
                <DropdownMenuSeparator className="bg-zinc-800" />
                <DropdownMenuItem onClick={onLogout} className="cursor-pointer focus:bg-zinc-800 text-red-400" data-testid="menu-logout">
                  <LogOut className="h-4 w-4 mr-2" /> Esci
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <>
              <Link to="/login" className="inline-flex px-4 py-2 text-sm font-display font-semibold text-zinc-100 hover:text-yellow-400 transition-colors" data-testid="navbar-login-btn">
                Accedi
              </Link>
              <Link to="/newsletter" className="inline-flex items-center px-4 py-2 text-sm font-display font-bold rounded-full bg-yellow-400 text-zinc-950 hover:bg-yellow-300 transition-colors" data-testid="navbar-register-btn">
                Newsletter
              </Link>
            </>
          )}
          <button onClick={() => setOpen(!open)} className="lg:hidden p-2 text-zinc-100" data-testid="mobile-menu-toggle">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/5 bg-zinc-950" data-testid="mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-1">
            {NAV.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-2.5 rounded-md text-sm font-display font-medium ${isActive ? "bg-zinc-900 text-yellow-400" : "text-zinc-300"}`
                }
              >
                {it.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
